import { Spacer, Text } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import styles from './Fields.module.scss'

export const SourceField = ({
  source_name,
  source_type
}: {
  source_name: string
  source_type: string
}) => {
  const { t } = useTranslation()

  return (
    <Column>
      <Text size={14} color='neutral-6'>
        {source_type === 'landing' ? t('word.landing.page') : t('word.popup')}
      </Text>

      <Row alignItems='center' className={styles.field}>
        <Text size={16} color='neutral'>
          {source_name}
        </Text>
      </Row>

      <Spacer space={10} />
    </Column>
  )
}
